
import { Options, Vue } from "vue-class-component";
import dayjs from "dayjs";
import MCommentPanel from "@/components/MCommentPanel.vue";
import MSubjectsInput from "@/components/MSubjectsInput.vue";
import MButton from "@/components/form/MButton.vue";
import MTextArea from "@/components/form/MTextArea.vue";
import MTextField from "@/components/form/MTextField.vue";
import { LearningSubject } from "@/entities/learning";
import store from "@/store";
import { Student, StudentGrade } from "@/entities/student";
import {
  createLearningTimer,
  timeStringToUnixtime,
  isValidTimerEnd
} from "@/api/learning";
import { saveErrorLog } from "@/api/error";

@Options({
  components: {
    MCommentPanel,
    MSubjectsInput,
    MButton,
    MTextArea,
    MTextField
  },
  watch: {
    learningLoading: function () {
      this.onUpdateLoading();
    }
  }
})
export default class LearningStart extends Vue {
  goal = "";
  subjects: LearningSubject[] = [];
  timerEnd = "";
  enteredLearningMinute = false;

  get learningLoading(): boolean {
    return store.state.learningLoading;
  }

  get studentGrade(): StudentGrade {
    return store.state.student?.data.grade ?? "その他";
  }

  get validData(): boolean {
    return (
      this.goal.length > 0 && this.subjects.length > 0 && this.validTimerEnd
    );
  }

  get validTimerEnd(): boolean {
    return !!this.timerEnd && isValidTimerEnd(this.timerEnd);
  }

  changeSubjects(subjects: LearningSubject[]) {
    this.subjects = [...subjects];
  }

  async startLearning() {
    if (!this.validData || !store.state.student) {
      return;
    }

    try {
      store.commit("SET_LOADING", true);
      store.commit("SET_LOAD_TEXT", "タイムキーパー起動中");
      const timerStart = dayjs().unix();
      const timerEnd = timeStringToUnixtime(this.timerEnd, timerStart);
      const { learningDocId } = await createLearningTimer(
        store.state.student.ref,
        this.goal,
        this.subjects,
        timerStart,
        timerEnd
      );
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
      this.$router.replace(`/learning/${learningDocId}/timer`);
    } catch (e) {
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
      alert(`タイムキーパーの起動に失敗しました\n\n${e}`);
      await saveErrorLog(
        store.state.student,
        e.code,
        e.message,
        "Failed to create learning timer"
      );
      return;
    }
  }

  async created() {
    this.timerEnd = dayjs().add(30, "minute").format("HH:mm");
    this.onUpdateLoading();
  }

  onUpdateLoading() {
    if (!store.state.learningLoading) {
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
      const learningTimers = store.state.learnings.filter(
        learning =>
          learning.data.meta &&
          learning.data.meta.timer &&
          learning.data.meta.timer.start > 0
      );
      if (learningTimers.length > 0) {
        alert("現在タイムキーパーで学習時間を記録しています");
        this.$router.replace(`/learning/${learningTimers[0].ref.id}/timer`);
      }
    } else {
      store.commit("SET_LOADING", true);
    }
  }
}
